import { FC } from 'react'
import { TableBodyProps } from './interface'
import {
  StyleTableBody,
  StyleTableRow,
  StyleTableBodyText,
  StyleNotFoundWrapper,
} from './style'

const TableBody: FC<TableBodyProps> = ({ data, columns, onClickRow }) => {
  const handleClickOnRow = (event: any) => {
    if (!!onClickRow) {
      const id = (event.target as HTMLElement)
        .closest('[data-id]')
        ?.getAttribute('data-id')
      const item = data[id]
      if (!!item) {
        onClickRow(item)
      }
    }
  }
  return (
    <StyleTableBody onClick={handleClickOnRow}>
      {!!data?.length ? (
        <>
          {data?.map((item: any, index: number) => (
            <StyleTableRow key={index} data-id={index}>
              {columns?.map((column: any, i: number) => (
                <StyleTableBodyText key={i + 5}>
                  {column.render
                    ? column.render(item, index + 1 || 1)
                    : item[column.key]
                      ? item[column.key]
                      : '-'}
                </StyleTableBodyText>
              ))}
            </StyleTableRow>
          ))}
        </>
      ) : (
        <StyleTableRow>
          <StyleTableBodyText
            colSpan={columns.length}
            style={{
              fontSize: 24,
              padding: '60px 0px',
              color: '#ddd',
              textAlign: 'center',
            }}
          >
            <StyleNotFoundWrapper>
              <p>No Data Found</p>
            </StyleNotFoundWrapper>
          </StyleTableBodyText>
        </StyleTableRow>
      )}
    </StyleTableBody>
  )
}

export default TableBody
